import React from 'react';
import CommentCard from "./CommentCard"

const CommentWrapper = ({comment, replies, post_id, errors, fields, onSubmission, addingComment, handleInputChange, handleShowCommentFormInSinglePage}) => {
    return (
        <ul>
            <CommentCard replies={replies} comment={comment} post_id={post_id} errors={ errors } fields={fields} onSubmission={(e, parent) => onSubmission(e, parent)} addingComment={addingComment}  handleInputChange={(e, field) => handleInputChange(e, field) }     handleShowCommentFormInSinglePage={(status)=> handleShowCommentFormInSinglePage(status)} />
            {createRepliesList(comment, replies,post_id, 0, errors, fields, onSubmission, addingComment, handleInputChange, handleShowCommentFormInSinglePage)}
        </ul>
    )
};


const createRepliesList = (comment, replies, post_id, index = 0, errors, fields, onSubmission, addingComment, handleInputChange, handleShowCommentFormInSinglePage) => {
    index = index + 1;
    let recursiveItems = [];
    for (let i = 0; i < replies.length; i++) {
        if (replies[i].comment_parent === comment.comment_ID) {
            recursiveItems = [...recursiveItems, replies[i]];
        }
    }
    return (
        recursiveItems.map(reply => {
            return (
                <ul  key={index}>
                    <CommentCard index={index} comment={reply} post_id={post_id} errors={ errors } fields={fields} onSubmission={(e, parent) => onSubmission(e, parent)} addingComment={addingComment}  handleInputChange={(e, field) => handleInputChange(e, field) }   handleShowCommentFormInSinglePage={(status)=> handleShowCommentFormInSinglePage(status)}  />
                    {createRepliesList(reply, replies,post_id, index, errors, fields, onSubmission, addingComment, handleInputChange, handleShowCommentFormInSinglePage)}
                </ul>
            )
        })
    )

};

export default CommentWrapper;